import {
  Badge,
  Box,
  Button,
  ButtonGroup,
  Container,
  Flex,
  Heading,
  HStack,
  Img,
  SimpleGrid,
  Slide,
  Square,
  useBreakpointValue,
  useColorModeValue,
  Image,
  BoxProps,
  useColorModeValue as mode,
  Circle,
  List,
} from "@chakra-ui/react";
import * as React from "react";
import { FiCheck } from "react-icons/fi";
import { chakra, HTMLChakraProps } from "@chakra-ui/react";

import { Stack, Text } from "@chakra-ui/react";

import {
  FiBarChart2,
  FiCamera,
  FiFilm,
  FiHome,
  FiInstagram,
  FiLinkedin,
  FiMic,
  FiMusic,
  FiTwitter,
} from "react-icons/fi";

import { As, ButtonProps, Icon } from "@chakra-ui/react";
import { BsCart4, BsSpeedometer2, BsPeopleFill } from "react-icons/bs";
import { FaGitSquare, FaPython } from "react-icons/fa";
import {
  IoRocketSharp,
  IoStatsChartOutline,
  IoStorefrontOutline,
} from "react-icons/io5";

import { TiFlowMerge } from "react-icons/ti";

export const formURL = "https://txt5ue1dsib.typeform.com/to/FLmy3BKJ";

const openFormInNewTab = () => {
  const newWindow = window.open(formURL, "_blank", "noopener,noreferrer");
  if (newWindow) newWindow.opener = null;
};

interface NavButtonProps extends ButtonProps {
  icon: As;
  label: string;
}

export const NavButton = (props: NavButtonProps) => {
  const { icon, label, ...buttonProps } = props;
  return (
    <Button variant="ghost-on-accent" justifyContent="start" {...buttonProps}>
      <HStack spacing="3">
        <Icon as={icon} boxSize="6" color="on-accent-subtle" />
        <Text>{label}</Text>
      </HStack>
    </Button>
  );
};

export const LogoNew = (props: HTMLChakraProps<"svg">) => (
  <chakra.svg
    color="accent"
    height="37"
    width="auto"
    viewBox="0 0 212 37"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <svg
      width="212"
      height="37"
      viewBox="0 0 212 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M124 0C121.239 0 119 2.23858 119 5V32C119 34.7614 121.239 37 124 37H207C209.761 37 212 34.7614 212 32V5C212 2.23858 209.761 0 207 0H124ZM139.382 14.7656H143.737C143.598 13.5857 143.28 12.5384 142.783 11.6236C142.292 10.7088 141.656 9.93655 140.874 9.30682C140.091 8.67045 139.193 8.18655 138.179 7.85511C137.171 7.52367 136.078 7.35795 134.898 7.35795C133.108 7.35795 131.497 7.76894 130.065 8.59091C128.634 9.40625 127.5 10.5928 126.665 12.1506C125.83 13.7083 125.412 15.5975 125.412 17.8182C125.412 20.0322 125.823 21.9181 126.645 23.4759C127.473 25.0336 128.6 26.2235 130.026 27.0455C131.457 27.8674 133.081 28.2784 134.898 28.2784C136.204 28.2784 137.374 28.0829 138.408 27.6918C139.448 27.294 140.343 26.7571 141.092 26.081C141.848 25.3982 142.448 24.6259 142.892 23.7642C143.343 22.8958 143.625 21.9943 143.737 21.0597L139.382 21.0398C139.283 21.5833 139.104 22.0672 138.845 22.4915C138.593 22.9157 138.275 23.277 137.891 23.5753C137.506 23.867 137.065 24.089 136.568 24.2415C136.078 24.3939 135.544 24.4702 134.967 24.4702C133.94 24.4702 133.035 24.2183 132.253 23.7145C131.471 23.2107 130.861 22.465 130.423 21.4773C129.992 20.4896 129.777 19.2699 129.777 17.8182C129.777 16.4062 129.992 15.2064 130.423 14.2188C130.854 13.2244 131.461 12.4687 132.243 11.9517C133.025 11.428 133.943 11.1662 134.997 11.1662C135.58 11.1662 136.121 11.2491 136.618 11.4148C137.122 11.5805 137.566 11.8191 137.95 12.1307C138.335 12.4422 138.65 12.8201 138.895 13.2642C139.14 13.7017 139.303 14.2022 139.382 14.7656ZM146.745 28H150.981V7.63636H146.745V28ZM157.267 27.3139C158.394 27.9702 159.73 28.2983 161.275 28.2983C162.819 28.2983 164.151 27.9702 165.272 27.3139C166.399 26.651 167.267 25.7296 167.877 24.5497C168.487 23.3632 168.792 21.9877 168.792 20.4233C168.792 18.8456 168.487 17.4669 167.877 16.2869C167.267 15.1004 166.399 14.179 165.272 13.5227C164.151 12.8598 162.819 12.5284 161.275 12.5284C159.73 12.5284 158.394 12.8598 157.267 13.5227C156.147 14.179 155.282 15.1004 154.672 16.2869C154.062 17.4669 153.757 18.8456 153.757 20.4233C153.757 21.9877 154.062 23.3632 154.672 24.5497C155.282 25.7296 156.147 26.651 157.267 27.3139ZM163.054 24.4205C162.584 24.8182 161.997 25.017 161.294 25.017C160.585 25.017 159.989 24.8182 159.505 24.4205C159.027 24.0161 158.666 23.4659 158.421 22.7699C158.182 22.0739 158.063 21.2817 158.063 20.3935C158.063 19.5052 158.182 18.7131 158.421 18.017C158.666 17.321 159.027 16.7708 159.505 16.3665C159.989 15.9621 160.585 15.7599 161.294 15.7599C161.997 15.7599 162.584 15.9621 163.054 16.3665C163.525 16.7708 163.88 17.321 164.118 18.017C164.364 18.7131 164.486 19.5052 164.486 20.3935C164.486 21.2817 164.364 22.0739 164.118 22.7699C163.88 23.4659 163.525 24.0161 163.054 24.4205ZM181.34 12.7273V21.4972C181.346 22.1799 181.211 22.7533 180.932 23.2173C180.66 23.6813 180.302 24.0327 179.858 24.2713C179.414 24.5033 178.937 24.6193 178.426 24.6193C177.624 24.6193 176.985 24.3575 176.507 23.8338C176.03 23.3101 175.788 22.5975 175.782 21.696V12.7273H171.546V22.4517C171.552 23.6449 171.771 24.669 172.202 25.5241C172.64 26.3793 173.246 27.0388 174.022 27.5028C174.797 27.9669 175.695 28.1989 176.716 28.1989C177.863 28.1989 178.834 27.9271 179.63 27.3835C180.432 26.84 181.005 26.1207 181.35 25.2259H181.509V28H185.576V12.7273H181.34ZM191.44 27.3537C192.381 27.9503 193.432 28.2486 194.592 28.2486C195.414 28.2486 196.11 28.1127 196.68 27.8409C197.256 27.5691 197.724 27.2277 198.082 26.8168C198.446 26.3991 198.728 25.9782 198.927 25.554H199.106V28H203.282V7.63636H199.056V15.2926H198.927C198.741 14.8816 198.469 14.464 198.112 14.0398C197.76 13.6089 197.296 13.2509 196.719 12.9659C196.149 12.6742 195.437 12.5284 194.582 12.5284C193.461 12.5284 192.431 12.8201 191.489 13.4034C190.555 13.9801 189.806 14.8518 189.242 16.0185C188.679 17.1785 188.397 18.6335 188.397 20.3835C188.397 22.0871 188.669 23.5256 189.212 24.6989C189.763 25.8655 190.505 26.7505 191.44 27.3537ZM197.664 24.321C197.193 24.6922 196.617 24.8778 195.934 24.8778C195.238 24.8778 194.651 24.6889 194.174 24.3111C193.703 23.9266 193.342 23.3963 193.09 22.7202C192.845 22.0374 192.722 21.2519 192.722 20.3636C192.722 19.482 192.845 18.7064 193.09 18.0369C193.335 17.3674 193.697 16.8438 194.174 16.4659C194.651 16.0881 195.238 15.8991 195.934 15.8991C196.617 15.8991 197.197 16.0814 197.674 16.446C198.151 16.8106 198.516 17.3277 198.768 17.9972C199.02 18.6667 199.146 19.4555 199.146 20.3636C199.146 21.2718 199.016 22.0639 198.758 22.7401C198.506 23.4162 198.141 23.9432 197.664 24.321Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M1.76989 28V7.63636H9.80398C11.3485 7.63636 12.6643 7.93134 13.7514 8.52131C14.8385 9.10464 15.6671 9.91667 16.2372 10.9574C16.8139 11.9915 17.1023 13.1847 17.1023 14.5369C17.1023 15.8892 16.8106 17.0824 16.2273 18.1165C15.6439 19.1506 14.7988 19.956 13.6918 20.5327C12.5914 21.1094 11.259 21.3977 9.6946 21.3977H4.57386V17.9474H8.99858C9.82718 17.9474 10.5099 17.8049 11.0469 17.5199C11.5904 17.2282 11.9948 16.8272 12.2599 16.3168C12.5317 15.7997 12.6676 15.2064 12.6676 14.5369C12.6676 13.8608 12.5317 13.2708 12.2599 12.767C11.9948 12.2566 11.5904 11.8622 11.0469 11.5838C10.5033 11.2988 9.81392 11.1562 8.97869 11.1562H6.07528V28H1.76989ZM23.7642 28.2884C22.7898 28.2884 21.9214 28.1193 21.1591 27.7812C20.3968 27.4366 19.7936 26.9295 19.3494 26.2599C18.9119 25.5838 18.6932 24.742 18.6932 23.7344C18.6932 22.8859 18.849 22.1733 19.1605 21.5966C19.4721 21.0199 19.8963 20.5559 20.4332 20.2045C20.9702 19.8532 21.58 19.5881 22.2628 19.4091C22.9522 19.2301 23.6747 19.1042 24.4304 19.0312C25.3187 18.9384 26.0346 18.8523 26.5781 18.7727C27.1217 18.6866 27.5161 18.5606 27.7614 18.3949C28.0066 18.2292 28.1293 17.9839 28.1293 17.6591V17.5994C28.1293 16.9697 27.9304 16.4825 27.5327 16.1378C27.1416 15.7931 26.5848 15.6207 25.8622 15.6207C25.0999 15.6207 24.4934 15.7898 24.0426 16.1278C23.5919 16.4593 23.2936 16.8769 23.1477 17.3807L19.2301 17.0625C19.429 16.1345 19.8201 15.3324 20.4034 14.6562C20.9867 13.9735 21.7391 13.4498 22.6605 13.0852C23.5885 12.714 24.6624 12.5284 25.8821 12.5284C26.7306 12.5284 27.5426 12.6278 28.3182 12.8267C29.1004 13.0256 29.7931 13.3338 30.3963 13.7514C31.0062 14.169 31.4867 14.706 31.8381 15.3622C32.1894 16.0118 32.3651 16.7907 32.3651 17.6989V28H28.348V25.8821H28.2287C27.9834 26.3594 27.6553 26.7803 27.2443 27.1449C26.8333 27.5028 26.3395 27.7846 25.7628 27.9901C25.1861 28.1889 24.5199 28.2884 23.7642 28.2884ZM24.9773 25.3651C25.6004 25.3651 26.1506 25.2424 26.6278 24.9972C27.1051 24.7453 27.4796 24.4072 27.7514 23.983C28.0232 23.5587 28.1591 23.0781 28.1591 22.5412V20.9205C28.0265 21.0066 27.8442 21.0862 27.6122 21.1591C27.3868 21.2254 27.1316 21.2884 26.8466 21.348C26.5616 21.401 26.2765 21.4508 25.9915 21.4972C25.7064 21.5369 25.4479 21.5734 25.2159 21.6065C24.7188 21.6795 24.2846 21.7955 23.9134 21.9545C23.5421 22.1136 23.2538 22.3291 23.0483 22.6009C22.8428 22.866 22.7401 23.1974 22.7401 23.5952C22.7401 24.1719 22.9489 24.6127 23.3665 24.9176C23.7907 25.2159 24.3277 25.3651 24.9773 25.3651ZM35.6513 28V12.7273H39.7578V15.392H39.9169C40.1953 14.4441 40.6626 13.7282 41.3189 13.2443C41.9751 12.7538 42.7308 12.5085 43.5859 12.5085C43.7981 12.5085 44.0268 12.5218 44.272 12.5483C44.5173 12.5748 44.7327 12.6113 44.9183 12.6577V16.4162C44.7195 16.3565 44.4444 16.3035 44.093 16.2571C43.7417 16.2107 43.4202 16.1875 43.1286 16.1875C42.5054 16.1875 41.9486 16.3234 41.4581 16.5952C40.9742 16.8603 40.5897 17.2315 40.3047 17.7088C40.0263 18.1861 39.8871 18.7363 39.8871 19.3594V28H35.6513ZM51.0259 28.2884C50.0515 28.2884 49.1831 28.1193 48.4208 27.7812C47.6585 27.4366 47.0553 26.9295 46.6112 26.2599C46.1737 25.5838 45.9549 24.742 45.9549 23.7344C45.9549 22.8859 46.1107 22.1733 46.4222 21.5966C46.7338 21.0199 47.158 20.5559 47.695 20.2045C48.2319 19.8532 48.8417 19.5881 49.5245 19.4091C50.2139 19.2301 50.9364 19.1042 51.6921 19.0312C52.5804 18.9384 53.2963 18.8523 53.8398 18.7727C54.3834 18.6866 54.7778 18.5606 55.0231 18.3949C55.2683 18.2292 55.391 17.9839 55.391 17.6591V17.5994C55.391 16.9697 55.1921 16.4825 54.7944 16.1378C54.4033 15.7931 53.8465 15.6207 53.1239 15.6207C52.3616 15.6207 51.7551 15.7898 51.3043 16.1278C50.8536 16.4593 50.5553 16.8769 50.4094 17.3807L46.4918 17.0625C46.6907 16.1345 47.0818 15.3324 47.6651 14.6562C48.2485 13.9735 49.0008 13.4498 49.9222 13.0852C50.8503 12.714 51.9241 12.5284 53.1438 12.5284C53.9923 12.5284 54.8043 12.6278 55.5799 12.8267C56.3621 13.0256 57.0548 13.3338 57.658 13.7514C58.2679 14.169 58.7485 14.706 59.0998 15.3622C59.4511 16.0118 59.6268 16.7907 59.6268 17.6989V28H55.6097V25.8821H55.4904C55.2451 26.3594 54.917 26.7803 54.506 27.1449C54.0951 27.5028 53.6012 27.7846 53.0245 27.9901C52.4478 28.1889 51.7816 28.2884 51.0259 28.2884ZM52.239 25.3651C52.8621 25.3651 53.4123 25.2424 53.8896 24.9972C54.3668 24.7453 54.7414 24.4072 55.0131 23.983C55.2849 23.5587 55.4208 23.0781 55.4208 22.5412V20.9205C55.2882 21.0066 55.1059 21.0862 54.8739 21.1591C54.6486 21.2254 54.3933 21.2884 54.1083 21.348C53.8233 21.401 53.5382 21.4508 53.2532 21.4972C52.9682 21.5369 52.7096 21.5734 52.4776 21.6065C51.9805 21.6795 51.5463 21.7955 51.1751 21.9545C50.8039 22.1136 50.5155 22.3291 50.31 22.6009C50.1045 22.866 50.0018 23.1974 50.0018 23.5952C50.0018 24.1719 50.2106 24.6127 50.6282 24.9176C51.0524 25.2159 51.5894 25.3651 52.239 25.3651ZM69.7937 34.0455C68.4215 34.0455 67.2449 33.8565 66.2638 33.4787C65.2894 33.1075 64.5138 32.6004 63.9371 31.9574C63.3604 31.3144 62.9859 30.5919 62.8136 29.7898L66.7312 29.2628C66.8505 29.5677 67.0394 29.8527 67.2979 30.1179C67.5565 30.383 67.8978 30.5952 68.3221 30.7543C68.753 30.92 69.2766 31.0028 69.8931 31.0028C70.8145 31.0028 71.5735 30.7775 72.1701 30.3267C72.7733 29.8826 73.0749 29.1368 73.0749 28.0895V25.2955H72.896C72.7103 25.7197 72.4319 26.1207 72.0607 26.4986C71.6895 26.8764 71.2122 27.1847 70.6289 27.4233C70.0456 27.6619 69.3496 27.7812 68.5408 27.7812C67.3941 27.7812 66.35 27.5161 65.4087 26.9858C64.4741 26.4489 63.7283 25.6302 63.1715 24.5298C62.6213 23.4228 62.3462 22.0241 62.3462 20.3338C62.3462 18.6037 62.628 17.1586 63.1914 15.9986C63.7549 14.8385 64.5039 13.9702 65.4386 13.3935C66.3799 12.8168 67.4106 12.5284 68.5309 12.5284C69.386 12.5284 70.1019 12.6742 70.6786 12.9659C71.2553 13.2509 71.7193 13.6089 72.0707 14.0398C72.4286 14.464 72.7037 14.8816 72.896 15.2926H73.055V12.7273H77.261V28.1491C77.261 29.4484 76.9428 30.5355 76.3065 31.4105C75.6701 32.2855 74.7885 32.9418 73.6616 33.3793C72.5413 33.8234 71.252 34.0455 69.7937 34.0455ZM69.8832 24.5994C70.5659 24.5994 71.1426 24.4304 71.6133 24.0923C72.0906 23.7476 72.4551 23.2571 72.707 22.6207C72.9656 21.9777 73.0948 21.2088 73.0948 20.3139C73.0948 19.419 72.9689 18.6435 72.717 17.9872C72.4651 17.3243 72.1005 16.8106 71.6232 16.446C71.146 16.0814 70.5659 15.8991 69.8832 15.8991C69.1871 15.8991 68.6005 16.0881 68.1232 16.4659C67.646 16.8371 67.2847 17.3542 67.0394 18.017C66.7942 18.6799 66.6715 19.4455 66.6715 20.3139C66.6715 21.1955 66.7942 21.9579 67.0394 22.6009C67.2913 23.2372 67.6526 23.7311 68.1232 24.0824C68.6005 24.4271 69.1871 24.5994 69.8832 24.5994ZM87.5323 28.2983C85.9878 28.2983 84.6521 27.9702 83.5252 27.3139C82.4049 26.651 81.5399 25.7296 80.93 24.5497C80.3202 23.3632 80.0153 21.9877 80.0153 20.4233C80.0153 18.8456 80.3202 17.4669 80.93 16.2869C81.5399 15.1004 82.4049 14.179 83.5252 13.5227C84.6521 12.8598 85.9878 12.5284 87.5323 12.5284C89.0768 12.5284 90.4092 12.8598 91.5295 13.5227C92.6564 14.179 93.5247 15.1004 94.1346 16.2869C94.7444 17.4669 95.0494 18.8456 95.0494 20.4233C95.0494 21.9877 94.7444 23.3632 94.1346 24.5497C93.5247 25.7296 92.6564 26.651 91.5295 27.3139C90.4092 27.9702 89.0768 28.2983 87.5323 28.2983ZM87.5522 25.017C88.2549 25.017 88.8415 24.8182 89.3121 24.4205C89.7828 24.0161 90.1374 23.4659 90.3761 22.7699C90.6213 22.0739 90.744 21.2817 90.744 20.3935C90.744 19.5052 90.6213 18.7131 90.3761 18.017C90.1374 17.321 89.7828 16.7708 89.3121 16.3665C88.8415 15.9621 88.2549 15.7599 87.5522 15.7599C86.8429 15.7599 86.2463 15.9621 85.7624 16.3665C85.2852 16.7708 84.9239 17.321 84.6786 18.017C84.44 18.7131 84.3207 19.5052 84.3207 20.3935C84.3207 21.2817 84.44 22.0739 84.6786 22.7699C84.9239 23.4659 85.2852 24.0161 85.7624 24.4205C86.2463 24.8182 86.8429 25.017 87.5522 25.017ZM102.039 19.1705V28H97.8036V12.7273H101.841V15.4219H102.02C102.358 14.5336 102.924 13.831 103.72 13.3139C104.515 12.7902 105.48 12.5284 106.613 12.5284C107.674 12.5284 108.599 12.7604 109.387 13.2244C110.176 13.6884 110.789 14.3513 111.227 15.2131C111.664 16.0682 111.883 17.089 111.883 18.2756V28H107.647V19.0312C107.654 18.0966 107.415 17.3674 106.931 16.8438C106.448 16.3134 105.781 16.0483 104.933 16.0483C104.363 16.0483 103.859 16.1709 103.422 16.4162C102.991 16.6615 102.653 17.0194 102.407 17.4901C102.169 17.9541 102.046 18.5142 102.039 19.1705Z"
        fill="url(#paint0_linear)"
      />
    </svg>

    <defs>
      <linearGradient
        id="paint0_linear"
        x1="44"
        y1="-1.78854"
        x2="44"
        y2="91.3879"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="currentColor" />
        <stop offset="1" stopColor="currentColor" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="417.5"
        y1="13.282"
        x2="417.5"
        y2="76.282"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="currentColor" />
        <stop offset="1" stopColor="currentColor" />
      </linearGradient>
    </defs>
  </chakra.svg>
);

export function SideDrawer() {
  return (
    <Flex
      as="section"
      minH={{
        base: "calc(100vh - 80px)",
        md: "calc(100vh - 72px)",
        sm: "calc(100vh - 72px)",
      }}
      bg="bg-canvas"
    >
      <Flex
        flex="1"
        bg="bg-accent"
        maxW={{ base: "full", sm: "xs" }}
        py={{ base: "6", sm: "8" }}
        px={{ base: "4", sm: "6" }}
      >
        <Stack justify="space-between" spacing="1" width="full">
          <Stack spacing="8" shouldWrapChildren>
            <Stack spacing="1">
              <NavButton label="Home" icon={FiHome} />
              <NavButton
                label="Writing"
                icon={FiBarChart2}
                aria-current="page"
              />
            </Stack>
            <Stack>
              <Text fontSize="sm" color="on-accent-muted" fontWeight="medium">
                Media
              </Text>
              <Stack spacing="1">
                <NavButton label="Movies" icon={FiFilm} />
                <NavButton label="Pictures" icon={FiCamera} />
                <NavButton label="Music" icon={FiMusic} />
                <NavButton label="Podcasts" icon={FiMic} />
              </Stack>
            </Stack>
            <Stack>
              <Text fontSize="sm" color="on-accent-muted" fontWeight="medium">
                Social
              </Text>
              <Stack spacing="1">
                <NavButton label="Twitter" icon={FiTwitter} />
                <NavButton label="Instagram" icon={FiInstagram} />
                <NavButton label="Linkedin" icon={FiLinkedin} />
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Flex>
    </Flex>
  );
}

export function LandingSiteHero() {
  return (
    <Box as="section" bg="bg-surface">
      <Box position="relative" height={{ lg: "720px" }}>
        <Container py={{ base: "16", md: "24" }} height="full">
          <Stack
            direction={{ base: "column", lg: "row" }}
            spacing={{ base: "16" }}
            align={{ lg: "center" }}
            height="full"
          >
            <Stack spacing={{ base: "8", md: "12" }}>
              <Stack spacing="4">
                <Badge
                  colorScheme="blue"
                  alignSelf="start"
                  size={useBreakpointValue({ base: "md", md: "lg" })}
                >
                  New infrastructure recipes
                </Badge>
                <Stack
                  spacing={{ base: "4", md: "6" }}
                  maxW={{ md: "xl", lg: "md", xl: "xl" }}
                >
                  <Heading size={useBreakpointValue({ base: "md", md: "xl" })}>
                    Create Python apps remarkably fast
                  </Heading>
                  <Text fontSize={{ base: "lg", md: "xl" }} color="muted">
                    The simplistic way to create and deliver python apps with
                    enterprise grade reliability, whether it is a prototype or
                    mission critical app, <b>we scale with you</b>.
                  </Text>
                </Stack>
              </Stack>
              <Stack direction={{ base: "column", md: "row" }} spacing="3">
                <Button
                  variant="primary"
                  size={useBreakpointValue({ base: "lg", md: "xl" })}
                  onClick={openFormInNewTab}
                >
                  Join Waitlist
                </Button>
              </Stack>
            </Stack>
            <Box
              pos={{ lg: "absolute" }}
              right="0"
              bottom="0"
              w={{ base: "full", lg: "50%" }}
              height={{ base: "96", lg: "full" }}
              sx={{
                clipPath: { lg: "polygon(7% 0%, 100% 0%, 100% 100%, 0% 100%)" },
              }}
            >
              <Img
                boxSize="full"
                objectFit="cover"
                src="https://tinyurl.com/yeyjvptc"
                alt="Lady at work"
              />
            </Box>
          </Stack>
        </Container>
      </Box>
    </Box>
  );
}

export function LandingPageStats() {
  const features = [
    {
      name: "Faster, builds and deploys",
      description:
        "Optimized infrastructure that reduces build times, giving you an intuitive, instant git-based workflow that gets your updates into production blazing fast.",
      icon: BsSpeedometer2,
    },
    {
      name: "Reliable infrastructure",
      description:
        "Deploy and host your python app on enterprise grade architecture, reducing downtime for your end users between updates and serving them on blazing fast servers.",
      icon: IoRocketSharp,
    },
    {
      name: "Collaborate Better",
      description:
        "Grant access to your full team easily to colloborate on your python apps allowing everyone to manage deployments and monitor services.",
      icon: BsPeopleFill,
    },
  ];
  return (
    <Box as="section" bg="bg-accent" color="on-accent">
      <Container py={{ base: "16", md: "24" }}>
        <Stack spacing={{ base: "12", md: "16" }}>
          <Stack
            spacing={{ base: "4", md: "5" }}
            align="center"
            textAlign="center"
          >
            <Stack spacing="3">
              <Heading size={useBreakpointValue({ base: "sm", md: "md" })}>
                Why Paragaon?
              </Heading>
            </Stack>
            <Text fontSize={{ base: "lg", md: "xl" }} maxW="3xl">
              Create a full stack python app <b>within minutes</b> with our
              fully managed cloud platform. Your app will be built to scale from
              the start.
            </Text>
          </Stack>
          <SimpleGrid
            columns={{ base: 1, md: 2, lg: 3 }}
            columnGap={8}
            rowGap={{ base: 10, md: 16 }}
          >
            {features.map((feature) => (
              <Stack
                key={feature.name}
                spacing={{ base: "4", md: "5" }}
                align="center"
                textAlign="center"
              >
                <Square
                  size={{ base: "10", md: "12" }}
                  bg="accent"
                  color="inverted"
                  borderRadius="lg"
                >
                  <Icon as={feature.icon} boxSize={{ base: "5", md: "6" }} />
                </Square>
                <Stack spacing={{ base: "1", md: "2" }}>
                  <Text fontSize={{ base: "lg", md: "xl" }} fontWeight="medium">
                    {feature.name}
                  </Text>
                  <Text>{feature.description}</Text>
                </Stack>
              </Stack>
            ))}
          </SimpleGrid>
        </Stack>
      </Container>
    </Box>
  );
}

export function LandingSiteHowItWorks() {
  const features = [
    {
      name: "Git Based Workflow",
      description:
        "Login with your GitHub account and we will provision everything you need to get started. With each git push we will auto build and deploy your updates with zero downtime.",
      icon: FaGitSquare,
    },
    {
      name: "Popular Python Packages Supported",
      description:
        "Whether it is Django, Celery, Django Rest Framework, Django Channels we've got you covered on setting them up and getting started.",
      icon: FaPython,
    },
    {
      name: "Automated Infrastructure / Scaling",
      description:
        "We will setup and scale your servers with demand in real time whether its HTTP servers or celery workers we've got you covered",
      icon: IoRocketSharp,
    },
    {
      name: "Continous Integration and Deployment",
      description:
        "We help ensure the code you deliver works across your entire system with ease. Our automated testing and deployment helps ensure a better experience for your users.",
      icon: TiFlowMerge,
    },
  ];
  return (
    <Box as="section" bg="bg-surface">
      <Container py={{ base: "16", md: "24" }}>
        <Stack spacing={{ base: "12", md: "16" }}>
          <Stack spacing={{ base: "4", md: "5" }} maxW="3xl">
            <Stack spacing="3">
              <Text
                fontSize={{ base: "sm", md: "md" }}
                fontWeight="semibold"
                color="accent"
              >
                Features
              </Text>
              <Heading size={useBreakpointValue({ base: "sm", md: "md" })}>
                How does it work?
              </Heading>
            </Stack>
            <Text color="muted" fontSize={{ base: "lg", md: "xl" }}>
              We make the process of creating and hosting python based apps as
              simple as possible with a few clicks. Get started within minutes
              whether it is a early prototype or mission critical app.
            </Text>
          </Stack>
          <Stack
            direction={{ base: "column", md: "row" }}
            spacing={{ base: "12", lg: "16" }}
          >
            <Stack
              spacing={{ base: "10", md: "12" }}
              maxW="xl"
              justify="center"
              width="full"
            >
              {features.map((feature) => (
                <Stack key={feature.name} spacing="4" direction="row">
                  <Square
                    size={{ base: "10", md: "12" }}
                    bg="accent"
                    color="inverted"
                    borderRadius="lg"
                  >
                    <Icon as={feature.icon} boxSize={{ base: "5", md: "6" }} />
                  </Square>
                  <Stack
                    spacing={{ base: "4", md: "5" }}
                    pt={{ base: "1.5", md: "2.5" }}
                  >
                    <Stack spacing={{ base: "1", md: "2" }}>
                      <Text
                        fontSize={{ base: "lg", md: "xl" }}
                        fontWeight="medium"
                      >
                        {feature.name}
                      </Text>
                      <Text color="muted">{feature.description}</Text>
                    </Stack>
                  </Stack>
                </Stack>
              ))}
            </Stack>
            <Box width="full" overflow="hidden">
              <Image
                maxW="100%"
                minH={{ base: "100%", lg: "560px" }}
                objectFit="cover"
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1740&q=80"
                alt="Developer"
              />
            </Box>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}

export function LandingSiteFooter() {
  return (
    <Box bg="bg-accent" color="on-accent">
      <Container as="footer" role="contentinfo" py={{ base: "12", md: "16" }}>
        <Stack spacing={{ base: "4", md: "5" }}>
          <Stack justify="space-between" direction="row" align="center">
            <LogoNew />
          </Stack>
          <Text fontSize="sm" color="on-accent-subtle">
            &copy; {new Date().getFullYear()} Paragon Cloud, Inc. All rights
            reserved.
          </Text>
        </Stack>
      </Container>
    </Box>
  );
}

export function LandingSiteReadyToGrow() {
  return (
    <Box as="section" bg="bg-accent" color="on-accent">
      <Container py={{ base: "16", md: "24" }}>
        <Stack spacing={{ base: "8", md: "10" }}>
          <Stack spacing={{ base: "4", md: "5" }} align="center">
            <Heading size={useBreakpointValue({ base: "sm", md: "md" })}>
              Ready to Grow?
            </Heading>
            <Text
              color="on-accent-muteed"
              maxW="2xl"
              textAlign="center"
              fontSize="xl"
            >
              With this beautiful and responsive React components you will
              realize your next project in no time.
            </Text>
          </Stack>
          <Stack
            spacing="3"
            direction={{ base: "column", sm: "row" }}
            justify="center"
          >
            <Button variant="secondary-on-accent" size="lg">
              Learn more
            </Button>
            <Button
              variant="primary-on-accent"
              size="lg"
              onClick={openFormInNewTab}
            >
              Join Waitlist
            </Button>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}

export const products = [
  {
    name: "Professional",
    price: "$50",
    icon: IoStatsChartOutline,
    description: "For accessible applications",
    features: ["1 App", "1 Concurrent Build", "1 User"],
  },
  {
    name: "Startup / Agency",
    price: "$250",
    icon: BsCart4,
    description: "For stunning online shops",
    features: ["1 - 5 Apps", "3 - 10 Concurrent Builds", "2-10 Users"],
  },
  {
    name: "Enterprise",
    price: "Lets chat",
    icon: IoStorefrontOutline,
    description: "For impressive landing pages",
    features: ["Unlimited Apps", "Unlimited Builds", "SSO / SAML"],
  },
];

export type ElementType<T extends ReadonlyArray<unknown>> =
  T extends ReadonlyArray<infer ElementType> ? ElementType : never;

export type Product = ElementType<typeof products>;

interface Props extends BoxProps {
  product: Product;
}

export const PricingCard = (props: Props) => {
  const { product } = props;
  return (
    <Box
      bg="bg-surface"
      borderRadius="2xl"
      boxShadow={mode("lg", "lg-dark")}
      px={{ base: "6", md: "8" }}
      py="8"
    >
      <Stack spacing="8" textAlign="center">
        <Stack spacing="5" align="center">
          <Circle bg={mode("blue.50", "whiteAlpha.50")} size="12">
            <Icon as={product.icon} boxSize="6" color="accent" />
          </Circle>
          <Stack>
            <Text fontSize="xl" color="accent" fontWeight="semibold">
              {product.name}
            </Text>
            <Heading size={useBreakpointValue({ base: "md", md: "lg" })}>
              {product.price}{" "}
              {product.name !== "Enterprise" ? (
                <Text color="muted" fontSize="md" style={{ display: "inline" }}>
                  per month
                </Text>
              ) : null}
            </Heading>
            <Text color="muted">{product.description}</Text>
          </Stack>
        </Stack>
        <List as="ul" spacing="4">
          {product.features.map((feature) => (
            <HStack key={feature} as="li" spacing="3">
              <Circle size="6" bg={mode("blue.50", "whiteAlpha.50")}>
                <Icon as={FiCheck} color="accent" />
              </Circle>
              <Text color="muted">{feature}</Text>
            </HStack>
          ))}
        </List>
        <Button variant="primary" size="lg" onClick={openFormInNewTab}>
          Join Waitlist
        </Button>
      </Stack>
    </Box>
  );
};

export function LandingSitePricing() {
  return (
    <Box as="section">
      <Container py={{ base: "16", md: "24" }}>
        <Stack spacing={{ base: "16", md: "24" }}>
          <Stack spacing={{ base: "4", md: "6" }}>
            <Stack spacing="3">
              <Text color="accent" fontWeight="semibold">
                Pricing
              </Text>
              <Heading size={useBreakpointValue({ base: "md", md: "lg" })}>
                Build, Deploy & Scale with Paragon.
              </Heading>
            </Stack>
            <Text fontSize={{ base: "lg", md: "xl" }} color="muted" maxW="3xl">
              Create and scale your python app intuitively with access to proven
              infrastructure. Make your python app today!
            </Text>
          </Stack>
          <SimpleGrid
            columns={{ base: 1, md: 2, lg: 3 }}
            columnGap="8"
            rowGap="6"
          >
            {products.map((product, id) => (
              <PricingCard key={id} product={product} />
            ))}
          </SimpleGrid>
        </Stack>
      </Container>
    </Box>
  );
}

export function SignUpToNewsLetter() {
  return (
    <Box bgGradient="linear(to-b, bg-accent 100%, bg-canvas 100%, )">
      <Container py={{ base: "16", md: "24" }}>
        <Box
          bg="bg-surface"
          py={{ base: "10", md: "16" }}
          px={{ base: "6", md: "16" }}
          borderRadius="lg"
          boxShadow={useColorModeValue("sm", "sm-dark")}
        >
          <Stack
            spacing={{ base: "8", md: "8" }}
            direction={{ base: "column", lg: "row" }}
            justify="center"
          >
            <Stack spacing={{ base: "4", md: "5" }}>
              <Heading size={useBreakpointValue({ base: "sm", md: "md" })}>
                Sign up for our waitlist
              </Heading>
              <Text fontSize={{ base: "lg", md: "xl" }} color="muted">
                Be the first to know when we release new components
              </Text>
              <Button variant="primary" size="lg" onClick={openFormInNewTab}>
                Join Waitlist
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}

export function TopBarComponent() {
  const isDesktop = useBreakpointValue({ base: false, lg: true });
  const [showSideDrawer, setShowSideDrawer] = React.useState(false);
  return (
    <Box>
      <Box as="section">
        <Box
          as="nav"
          bg="bg-surface"
          boxShadow={useColorModeValue("sm", "sm-dark")}
        >
          <Container py={{ base: "4", lg: "5" }}>
            <HStack spacing="10" justify="space-between">
              <LogoNew />
              {isDesktop ? (
                <Flex justify="space-between" flex="1">
                  <ButtonGroup variant="link" spacing="8">
                    {/* {["Product", "Pricing", "Resources", "Support"].map(
                      (item) => (
                        <Button key={item}>{item}</Button>
                      )
                    )} */}
                  </ButtonGroup>
                  <HStack spacing="3">
                    {/* <Button variant="ghost">Sign in</Button> */}
                    <Button variant="primary" onClick={openFormInNewTab}>
                      Join Waitlist
                    </Button>
                  </HStack>
                </Flex>
              ) : (
                <div></div>
                // <IconButton
                //   variant="ghost"
                //   icon={<FiMenu fontSize="1.25rem" />}
                //   aria-label="Open Menu"
                //   onClick={() => {
                //     setShowSideDrawer(!showSideDrawer);
                //   }}
                // />
              )}
            </HStack>
          </Container>
        </Box>
      </Box>

      <Slide
        direction="left"
        in={showSideDrawer && !isDesktop}
        style={{ width: "250px", top: "", bottom: "", left: "", zIndex: "99" }}
      >
        <SideDrawer />
      </Slide>
      <LandingSiteHero />
      <LandingPageStats />

      <LandingSiteHowItWorks />
      <SignUpToNewsLetter />

      <LandingSitePricing />
      <LandingSiteFooter />
    </Box>
  );
}
